import { CariPicker } from "@/components/common/CariPicker";
import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { Field, sel } from "@/lib/finance";

export const TYPES = [["malzeme", "Malzeme"], ["iscilik", "İşçilik"], ["hizmet", "Hizmet"]];
export const UNITS = ["adet", "kg", "ton", "m²", "m³", "m", "torba", "paket", "lt", "diğer"];
const LABOR = [["gun", "Gün"], ["saat", "Saat"], ["goturu", "Götürü"]];

export const isComputed = (f) => f.gider_turu === "malzeme" || (f.gider_turu === "iscilik" && f.labor_mode !== "goturu");
export const computedAmount = (f) => {
  const q = Number(f.quantity), p = Math.round(Number(f.unit_price) * 100);
  return q > 0 && p > 0 ? Math.round(q * p) / 100 : 0;
};
export const typeOk = (f) => {
  if (f.gider_turu === "malzeme") return Number(f.quantity) > 0 && f.unit && Number(f.unit_price) > 0;
  if (f.gider_turu === "iscilik") return f.worker_name.trim() && (f.labor_mode === "goturu" ? Number(f.amount) > 0 : Number(f.quantity) > 0 && Number(f.unit_price) > 0);
  if (f.gider_turu === "hizmet") return (f.provider_mode === "supplier" ? f.provider_supplier_id : f.provider_name.trim()) && Number(f.amount) > 0;
  return false;
};

function Segmented({ value, onChange, options, testid }) {
  return (
    <div className="inline-flex rounded-md border border-slate-300 overflow-hidden w-full" role="radiogroup" data-testid={testid}>
      {options.map(([k, l]) => (
        <button key={k} type="button" role="radio" aria-checked={value === k} onClick={() => onChange(k)} data-testid={`${testid}-${k}`}
          className={`flex-1 h-9 text-sm font-medium transition-colors border-r last:border-r-0 border-slate-300 ${value === k ? "bg-slate-900 text-white" : "bg-white text-slate-700 hover:bg-slate-50"}`}>{l}</button>
      ))}
    </div>
  );
}

export function TypeFields({ f, setF }) {
  const [sug, setSug] = useState({ workers: [], providers: [] });
  useEffect(() => { api.get("/insaat/name-suggestions").then(({ data }) => setSug(data)).catch(() => {}); }, []);
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e?.target ? e.target.value : e }));
  const qtyPrice = (unitLabel, priceLabel) => (<>
    <Field label={`Miktar *${unitLabel ? ` (${unitLabel})` : ""}`}><Input type="number" min="0.001" step="0.001" inputMode="decimal" value={f.quantity} onChange={set("quantity")} data-testid="expense-quantity-input" /></Field>
    <Field label={`${priceLabel} *`}><Input type="number" min="0.01" step="0.01" inputMode="decimal" value={f.unit_price} onChange={set("unit_price")} data-testid="expense-unit-price-input" /></Field>
  </>);
  return (
    <>
      <Field label="Gider Türü *" className="col-span-full">
        <Segmented value={f.gider_turu} onChange={set("gider_turu")} options={TYPES} testid="expense-type" />
        {!f.gider_turu && <div className="text-[11px] text-amber-700 mt-1" data-testid="expense-type-required">Gider türü seçin</div>}
      </Field>
      {f.gider_turu === "malzeme" && (<>
        {qtyPrice("", "Birim Fiyat")}
        <Field label="Birim *"><select className={`${sel} w-full`} value={f.unit} onChange={set("unit")} data-testid="expense-unit-select"><option value="">Seçin…</option>{UNITS.map((u) => <option key={u}>{u}</option>)}</select></Field>
        <div className="text-[11px] text-slate-500 self-end pb-2">Şantiyeye doğrudan; stok etkisi yok.</div>
      </>)}
      {f.gider_turu === "iscilik" && (<>
        <Field label="Usta / Taşeron Adı *" className="col-span-2"><Input list="insaat-workers" value={f.worker_name} onChange={set("worker_name")} maxLength={120} data-testid="expense-worker-input" />
          <datalist id="insaat-workers">{sug.workers.map((w) => <option key={w} value={w} />)}</datalist></Field>
        <Field label="Süre Tipi" className="col-span-2"><Segmented value={f.labor_mode} onChange={set("labor_mode")} options={LABOR} testid="expense-labor-mode" /></Field>
        {f.labor_mode !== "goturu" && qtyPrice(f.labor_mode === "gun" ? "gün" : "saat", "Birim Ücret")}
      </>)}
      {f.gider_turu === "hizmet" && (<>
        <Field label="Hizmet Veren *" className="col-span-2">
          <div className="flex gap-2">
            <select className={`${sel} w-28 shrink-0`} value={f.provider_mode} onChange={set("provider_mode")} data-testid="expense-provider-mode"><option value="text">Serbest</option><option value="supplier">Cari</option></select>
            {f.provider_mode === "supplier"
              ? <div className="w-full min-w-0"><CariPicker value={f.provider_supplier_id} label={f.provider_label || f.provider_supplier_name} testid="expense-provider-supplier"
                onChange={(o) => setF((x) => ({ ...x, provider_supplier_id: o?.id || "", provider_label: o?.label }))} /></div>
              : <><Input list="insaat-providers" value={f.provider_name} onChange={set("provider_name")} maxLength={160} data-testid="expense-provider-input" />
                <datalist id="insaat-providers">{sug.providers.map((w) => <option key={w} value={w} />)}</datalist></>}
          </div>
        </Field>
        <Field label="Hizmet Tanımı" className="col-span-2"><Input value={f.service_description} onChange={set("service_description")} maxLength={500} data-testid="expense-service-input" /></Field>
      </>)}
    </>
  );
}
